import { gql } from '@urql/vue';

export const IMPERSONATE_MUTATION = gql`
  mutation ($input: TokenLoginInput!) {
    tokenLogin(input: $input) {
      access_token
      refresh_token
      expires_in
      user {
        id
        name
        first_name
        last_name
        infix
        roles {
          role_data {
            ... on Advisor {
              has_mandate
              type
            }
          }
        }
      }
    }
  }
`;
